import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import React from "react";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Wraps hyphens and apostrophes in a sans-serif span to avoid font watermarks
 * in the Palo display font. Use this for any text rendered with font-display.
 */
export function renderDisplayText(text: string): React.ReactNode {
  // Split on hyphens and apostrophes while keeping the delimiters
  const parts = text.split(/(-|'|')/);
  
  if (parts.length === 1) {
    return text;
  }

  return parts.map((part, index) => {
    if (part === '-' || part === "'" || part === "'") {
      return React.createElement('span', { key: index, className: 'font-sans' }, part);
    }
    return part;
  });
}
